import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { SOFTLINE_ROUTE_MDC_STOCK_POSTING_SETUP_STOCK } from '../mdc-stock-posting.shared';
import { StockPostingService } from '../services/stock-posting.service';

/** Capture routes need an open document; otherwise start the setup wizard. */
export const openStockPostingGuard: CanActivateFn = async () => {
  const stockPostingService = inject(StockPostingService);
  const router = inject(Router);

  const stockPosting =
    stockPostingService.stockPosting() ?? (await stockPostingService.load());

  if (stockPosting) return true;

  return new RedirectCommand(
    router.createUrlTree([SOFTLINE_ROUTE_MDC_STOCK_POSTING_SETUP_STOCK]),
    {
      replaceUrl: true,
    }
  );
};
